import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"VueTables__sort"},[(_vm.props.sortable)?_c(VIcon,[_vm._v(" "+_vm._s(_vm.icon)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }